import type { IconProps } from '@common/Icon/Icon';
import { IconColor } from '@common/Icon/Icon';
import Tippy from '@tippyjs/react';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import styles from './TooltipIcon.module.scss';
import { APP_NAME } from '@libs/constants';

export interface TooltipIconProps extends IconProps {
  tooltipText?: string;
  tooltipContent?: ReactNode;
  iconInline?: boolean;
  interactive?: boolean;
  className?: string;
}

export const TooltipIcon = ({
  id,
  size,
  tooltipText,
  tooltipContent,
  color,
  iconInline,
  primary,
  interactive,
  className,
}: TooltipIconProps) => {
  if (!tooltipText && !tooltipContent) {
    return null;
  }

  return (
    <div
      data-testid="icon-wrapper"
      className={classNames(styles.tooltipIconWrapper, iconInline ? styles.iconInline : '')}
    >
      {/* if available, use ReactNode as content, but there might be cases where the html has to be set from text (like some tooltip texts that fully come (including html) from the translatation file) */}
      <Tippy
        content={
          tooltipContent ||
          (tooltipText && (
            <p className={classNames('min-w-[250px]')} dangerouslySetInnerHTML={{ __html: tooltipText }} />
          ))
        }
        interactive={interactive}
        theme="light-border"
      >
        {/* can not just use icon here since the icon component uses additional elements that change the placement of the tippy even though they are invisible */}
        <svg
          role="img"
          data-testid="icon-svg"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          className={classNames(
            `w-${size}`,
            `h-${size}`,
            primary && !color && IconColor.ORANGE,
            'fill-current',
            'inline-block',
            color ?? '',
            color === IconColor.DARK_GRAY && 'group-hover:text-white',
            className
          )}
        >
          <use data-testid="icon-svg-use" xlinkHref={`/_${APP_NAME}/icons/icon-sprite.svg#${id}`} />
        </svg>
      </Tippy>
    </div>
  );
};
